import React from 'react'
import { formatCurrency } from '../lib/currency-formatter'

import { AccountDetails } from '../types'
import { Translate } from 'react-redux-i18n'
import { TradingAccount } from '@bdswiss/mt4-connector'
import HelpTooltip from './HelpTooltip'
import { getAccountLabel } from '../utils/common-utils'

export interface Props {
  account: AccountDetails
  loginInfo: TradingAccount
  active: boolean
  locale: string
  onSelect: (accountId: string, id: number) => void
  isFirst: boolean
}

const AccountBalance = ({ account, loginInfo, active, locale, onSelect, isFirst }: Props) => {
  const { balance, equity, margin, freeMargin, credit } = loginInfo
  const marginLevel = margin ? (equity / margin) * 100 : 0
  const additionalRows: any[] = []
  const label = getAccountLabel(account, locale)
  if (active) {
    additionalRows.push(
      <div key={0} className="account__row">
        <div className="d-flex account-additional__title">
          <Translate value={'equity'} />
          <HelpTooltip content="helpEquity" />
        </div>
        <div className="account-additional__total">
          {formatCurrency(equity, account.currency, locale)}
        </div>
      </div>
    )
    additionalRows.push(
      <div key={1} className="account__row">
        <div className="d-flex account-additional__title">
          <Translate value={'bonus'} />
          <HelpTooltip content="helpBonus" />
        </div>
        <div className="account-additional__total">
          {formatCurrency(credit, account.currency, locale)}
        </div>
      </div>
    )
    additionalRows.push(
      <div key={2} className="account__row">
        <div className="d-flex account-additional__title">
          <Translate value={'margin'} />
          <HelpTooltip content="helpUsedMargin" />
        </div>
        <div className="account-additional__total">
          {formatCurrency(margin, account.currency, locale)}
        </div>
      </div>
    )
    additionalRows.push(
      <div key={3} className="account__row">
        <div className="d-flex account-additional__title">
          <Translate value={'marginLevel'} />
          <HelpTooltip content="helpMarginLevel" />
        </div>
        <div className="account-additional__total">
          {marginLevel ? ` ${marginLevel.toFixed(2)}%` : ' -'}
        </div>
      </div>
    )
    additionalRows.push(
      <div key={4} className="account__row">
        <div className="d-flex account-additional__title">
          <Translate value={'freeMargin'} />
          <HelpTooltip content="helpFreeMargin" />
        </div>
        <div className="account-additional__total">
          {formatCurrency(freeMargin, account.currency, locale)}
        </div>
      </div>
    )
  }
  return (
    <div className="d-flex flex-row align-items-start">
      <div
        className="custom-control custom-radio"
        onClick={e => onSelect(account.login, account.id)}
      >
        <input type="radio" name={account.login} id={account.login} defaultChecked={active} />
        <label className="custom-control-label" htmlFor={account.login} />
      </div>
      <div
        className="account"
        onClick={e => onSelect(account.login, account.id)}
        data-cy={account.__typename.indexOf('Demo') > 0 ? 'practiceAccount' : 'realAccount'}
      >
        <div className="account__row">
          <div className="account__name">
            <span>{label}</span>
          </div>
          <div className="account__balance d-flex align-items-center">
            <HelpTooltip content="helpBalance" place={isFirst ? 'bottom' : 'left'} />
            <Translate value={'balance'} />
          </div>
        </div>
        <div className="account__row">
          <div className="account__number">{account.login}</div>
          <div className="account__total">
            {formatCurrency(active ? balance : account.balance, account.currency, locale)}
          </div>
        </div>
        <div className="account-additional">{additionalRows}</div>
      </div>
    </div>
  )
}

export default AccountBalance
